export const PasswordRegex = {
    LOWERCASEALPHABET: /[a-z]/,
    UPPERCASEALPHABET: /[A-Z]/,
    DIGIT: /[\d]/,
    ALPHANUMERIC: /^[a-zA-Z0-9]+$/,
    LENGTH: /^.{8,16}$/
};

export enum PasswordStrengthType {
    Weak = 0,
    Medium = 1,
    Strong = 2
}

export class PasswordStrengthResult {
    public PasswordStrengthType: PasswordStrengthType;
    public LengthValidated: boolean;
    public CharacterPatternValidated: boolean;
    public UpperCasePatternValidated: boolean;
    public LowerCasePatternValidated: boolean;
    public NumberCharacterPatternValidated: boolean;
    public SpecialCharacterPatternValidated: boolean;
    public Status: boolean;
    public ConFirmPasswordValidated: boolean;

    constructor() {
        this.PasswordStrengthType = PasswordStrengthType.Weak;
        this.LengthValidated = false;
        this.CharacterPatternValidated = false;
        this.UpperCasePatternValidated = false;
        this.LowerCasePatternValidated = false;
        this.NumberCharacterPatternValidated = false;
        this.SpecialCharacterPatternValidated = false;
        this.Status = false;
        this.ConFirmPasswordValidated = false;
    }
}

